<template>
    <div>
        <section class="section-shaped my-0">
            <div class="shape shape-style-1 shape-default shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="container shape-container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3 text-white">Contact Information</h2>
                        <p class="lead text-white">Virtual office</p>
                    </div>
                </div>

                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon
                            name="ni ni-cart"
                            size="lg"
                            gradient="white"
                            shadow
                            round
                            color="primary"
                        ></icon>
                        <a href="mailto:sales@aiwa.cloud" class="d-block mb-1">
                            <h5 class="text-white mt-3">sales@aiwa.cloud</h5>
                        </a>
                        <p class="text-white mt-3">Sales department</p>
                    </div>
                    <div class="col-lg-4">
                        <icon
                            name="ni ni-sound-wave"
                            size="lg"
                            gradient="white"
                            shadow
                            round
                            color="primary"
                        ></icon>
                        <a href="mailto:marketing@aiwa.cloud" class="d-block mb-1">
                            <h5 class="text-white mt-3">marketing@aiwa.cloud</h5>
                        </a>
                        <p class="text-white mt-3">Marketing and Advertising</p>
                    </div>
                    <div class="col-lg-4">
                        <icon
                            name="ni ni-support-16"
                            size="lg"
                            gradient="white"
                            shadow
                            round
                            color="primary"
                        ></icon>
                        <a href="mailto:support@aiwa.cloud" class="d-block mb-1">
                            <h5 class="text-white mt-3">support@aiwa.cloud</h5>
                        </a>
                        <p class="text-white mt-3">Technical support</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- <section class="section section-lg pt-lg section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Your project is very important to us.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Your name"
                                        addon-left-icon="ni ni-user-run">
                            </base-input>
                            <base-input alternative
                                        placeholder="Email address"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                                              cols="80" placeholder="Type a message..."></textarea>
                            </base-input>
                            <base-button type="default" round block size="lg">
                                Send Message
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>-->

    </div>
</template>
<script>
export default {};
</script>
<style>
</style>
